<template>
  <div class="container mb-5">

    <div class="row">
      <InfoCard v-if="!isEdit" class="col-lg-4" :info="tutorialInfo"></InfoCard>

      <v-modal v-if="showInvalidStudentCountModal" @close="showInvalidStudentCountModal = false">
        <template v-slot:header>
          <h3>Ongeldig aantal leerlingen</h3>
        </template>
        <template v-slot:body>
          <p>
            Het aantal Meisjes/Jongens/X komt niet overeen met het aangegeven totaal aantal leerlingen.
          </p>
        </template>
        <template v-slot:footer>
          <button class="btn btn-secondary" @click="showInvalidStudentCountModal = false">Terug</button>
        </template>
      </v-modal>

      <div class="col-lg-8">
        <div class="card">
          <p class="title">{{ title }}</p>

          <div class="edit-buddy-form">
            <div class="form-group">
              <h3>Klas naam</h3>
              <input id="buddy-name-field" type="text" class="form-control" v-model="buddyConfig.className"
                     placeholder="vb.: Klas 3B">
            </div>

            <div class="form-group">
              <h3>Aantal leerlingen</h3>
              <input id="buddy-student-count-field" type="text" class="form-control" v-model="buddyConfig.studentCount"
                     placeholder="vb.: 26">
            </div>

            <div v-if="FakeFeatureFlags.features.GRADE_DROPDOWN" class="form-group">
              <h3>leerjaar</h3>
              <IconDropdownButton id="grade-select-dropdown-button" class="w-100" iconName=""
                                  :buttonText=gradeSelectButtonTitle
                                  @click="gradeDropdownOpen = !gradeDropdownOpen"></IconDropdownButton>
              <ul class="dropdown-menu" v-if="gradeDropdownOpen">
                <li :key="grade.id" v-for="grade in grades" class="dropdown-item"
                    @click="gradeSelected(grade)">
                  {{ grade.name }}
                </li>
              </ul>
            </div>

            <div v-if="FakeFeatureFlags.features.GENDER_FIELDS" class="form-group">
              <h3>Gender</h3>

              <div class="" style="display: flex; flex-direction: row; align-items: center;">
                <h6 style="margin-right: 10px;">Meisjes</h6>
                <input id="gender-boys-field" type="number" min="0" max="100" class="form-control" placeholder="vb.: 0"
                       v-model="buddyConfig.genders.girls">
              </div>

              <div class="" style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;">
                <h6 style="margin-right: 10px;">Jongens</h6>
                <input id="gender-boys-field" type="number" min="0" max="100" class="form-control" placeholder="vb.: 0"
                       v-model="buddyConfig.genders.boys">
              </div>

              <div class="" style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;">
                <h6 style="margin-right: 10px;">X</h6>
                <input id="gender-boys-field" type="number" min="0" max="100" class="form-control" placeholder="vb.: 0"
                       v-model="buddyConfig.genders.other">
              </div>

            </div>

            <div class="form-group">
              <h3>School</h3>
              <IconDropdownButton id="school-select-dropdown-button" class="w-100" iconName=""
                                  :buttonText=schoolSelectButtonTitle
                                  @click="schoolSelectDropdownClicked"></IconDropdownButton>
              <ul class="dropdown-menu" v-if="dropdownOpen">
                <li :key="school.id" v-for="school in userSchools" class="dropdown-item"
                    @click="selectRelatedSchool(school)">
                  {{ school.name }} - {{ school.address }} {{ school.postalCode }}
                </li>
                <li class="dropdown-item" @click="openSchoolAdd">Nieuwe school kiezen</li>
              </ul>
            </div>

            <ZipSchoolForm v-show="otherSchoolSectionOpen" @selectSchool="selectSchool"
                           :selected-school="selectedSchool" :closeOnSelected="true"></ZipSchoolForm>

            <v-button class="save-changes-button" :buttonText="isEdit ? 'Data wijzigen' : 'Buddy aanmaken'"
                      v-on:clicked="saveDataClicked" :enabled="isValid"></v-button>
            <a class="cancel-button" href="#" v-on:click.prevent="cancelClicked">Annuleren</a>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import IconDropdownButton from "@/components/UI/IconDropdownButton";
import InfoCard from "@/components/Common/InfoCard";
import ZipSchoolForm from "@/components/ZipSchoolForm"
import log from "@/utils/logger";
import {SchoolApi, BuddyApi} from "sandpiper_api";
import FakeFeatureFlags from "@/mixins/FakeFeatureFlags.js";
import VModal from "@/components/UI/VModal.vue";

export default {
  name: "CreateBuddy",
  components: {VModal, VButton, IconDropdownButton, InfoCard, ZipSchoolForm},
  inject: ["doApiRequest"],
  props: {
    initialClassName: String,
    initialStudentCount: Number,
    initialSchoolId: Number,
    initialBoys: String,
    initialGirls: String,
    initialOther: String,
    initialGrade: String,
  },
  data() {
    return {
      FakeFeatureFlags: FakeFeatureFlags,
      savingBuddy: false,
      buddyConfig: {
        school: {},
        grade: null,
        genders: {
          boys: 0,
          girls: 0,
          other: 0,
        },
        className: null,
        studentCount: null,
      },
      tutorialInfo: {
        id: "tutorial_buddy",
        title: "Welkom op het Beweegbuddy platform!",
        body: "Maak een beweegbuddy voor je klas aan om van start te gaan. <br /> <br /> Wanneer je beweegbuddy is aangemaakt kan je met behulp van de <b>Agenda</b> activiteiten beginnen inplannen voor je klas. <br /> <br />  Indien je meerdere beweegbuddies wil aanmaken voor meerdere klassen en/of scholen kan dat via je <b>Profiel</b>."
      },
      grades: [
        {id: 1, name: "1ste leerjaar"},
        {id: 2, name: "2de leerjaar"},
        {id: 3, name: "3de leerjaar"},
        {id: 4, name: "4de leerjaar"},
        {id: 5, name: "5de leerjaar"},
        {id: 6, name: "6de leerjaar"},
      ],
      dropdownOpen: false,
      gradeDropdownOpen: false,
      otherSchoolSectionOpen: false,
      fetchingUserSchools: false,
      showInvalidStudentCountModal: false,
      userSchools: [],
      selectedSchool: null,
      selectedGrade: null,
    }
  },
  computed: {
    isEdit()
    {
      return !!this.$route.params.id;
    },
    title()
    {
      if (this.isEdit)
      {
        return "Beweegbuddy aanpassen";
      }
      else
      {
        return "Beweegbuddy aanmaken";
      }
    },
    schoolSelectButtonTitle()
    {
      if (this.selectedSchool !== null)
      {
        return this.selectedSchool.name + " - " + this.selectedSchool.address + " " + this.selectedSchool.postalCode;
      }
      else if (this.otherSchoolSectionOpen)
      {
        return "Nieuwe school kiezen";
      }
      else
      {
        return "School selecteren";
      }
    },
    gradeSelectButtonTitle()
    {
      if (this.selectedGrade !== null)
      {
        return this.selectedGrade.name;
      }
      else
      {
        return "Leerjaar selecteren";
      }
    },
    isValid()
    {
      if (this.buddyConfig.className === "" || this.buddyConfig.className === null)
      {
        return false;
      }

      if (this.buddyConfig.studentCount === "" || this.buddyConfig.studentCount === null)
      {
        return false;
      }

      if (this.selectedSchool === null)
      {
        return false;
      }

      if (FakeFeatureFlags.features.GRADE_DROPDOWN && this.selectedGrade === null)
      {
        return false;
      }

      return true;
    }
  },
  methods: {
    saveDataClicked()
    {
      if (this.studentCountCorrect()) {
        this.saveBuddy();
      } else {
        this.showIncorrectStudentCountMessage();
      }
    },
    studentCountCorrect() {
      let genderCount = parseInt(this.buddyConfig.genders.boys) + parseInt(this.buddyConfig.genders.girls) + parseInt(this.buddyConfig.genders.other);
      return genderCount === parseInt(this.buddyConfig.studentCount);
    },
    showIncorrectStudentCountMessage() {
      this.showInvalidStudentCountModal = true;
    },
    cancelClicked()
    {
      this.$router.push({ name: "profile" });
    },
    toggleDropdown()
    {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown()
    {
      this.dropdownOpen = false;
    },
    closeGradeDropdown()
    {
      this.gradeDropdownOpen = false;
    },
    schoolSelectDropdownClicked()
    {
      this.toggleDropdown();
    },
    selectRelatedSchool(school)
    {
      this.selectSchool(school);
      this.closeDropdown();
      this.closeOtherSchoolSection();
    },
    selectSchool(school)
    {
      this.selectedSchool = school;
    },
    gradeSelected(grade)
    {
      this.selectedGrade = grade;
      this.closeGradeDropdown();
    },
    openSchoolAdd()
    {
      this.closeDropdown();
      this.otherSchoolSectionOpen = true;
    },
    closeOtherSchoolSection()
    {
      this.otherSchoolDropdownOpen = false;
      this.otherSchoolSectionOpen = false;
    },
    async fetchUserSchools()
    {
      try
      {
        this.fetchingUserSchools = true;
        this.userSchools = await this.doApiRequest(() => new SchoolApi().getCurrentUserSchools());

        this.setInitialSchool();
      }
      catch (e)
      {
        log.error("Failed to fetch user schools - %o", e);
      }
      finally
      {
        this.fetchingUserSchools = false;
      }
    },
    async saveBuddy()
    {
      try
      {
        this.savingBuddy = true;

        this.buddyConfig.school = this.selectedSchool;

        if (FakeFeatureFlags.features.GRADE_DROPDOWN)
        {
          this.buddyConfig.grade = this.selectedGrade.id;
        }
        

        if (this.isEdit)
        {
          await this.doApiRequest(() => new BuddyApi().updateBuddy(this.$route.params.id, {
            id: this.$route.params.id,
            buddyConfig: this.buddyConfig
          }));

          await this.$router.push({ name: "profile" });
        }
        else
        {
          await this.doApiRequest(() => new BuddyApi().createBuddy({
            buddyConfig: this.buddyConfig
          }));

          if (this.$route.query.referer)
          {
            await this.$router.push({ path: this.$route.query.referer });
          }
          else
          {
            await this.$router.push({ name: "profile" });
          }
        }
      }
      catch (e)
      {
        log.error("Failed to save buddy - %o", e);
      }
      finally
      {
        this.savingBuddy = false;
      }
    },
    setInitialSchool()
    {
      if (this.initialSchoolId)
      {
        this.userSchools.forEach(school =>
        {
          if (school.id === this.initialSchoolId)
          {
            this.buddyConfig.school = school;
            this.selectedSchool = school;
          }
        });
      }
    },
  },
  created()
  {
    if (this.initialClassName)
    {
      this.buddyConfig.className = this.initialClassName;
    }

    if (this.initialStudentCount)
    {
      this.buddyConfig.studentCount = this.initialStudentCount;
    }

    if (this.initialBoys)
    {
      this.buddyConfig.genders.boys = this.initialBoys;
    }

    if (this.initialGirls)
    {
      this.buddyConfig.genders.girls = this.initialGirls;
    }

    if (this.initialOther)
    {
      this.buddyConfig.genders.other = this.initialOther;
    }


    if (this.initialGrade)
    {
      this.selectedGrade = this.grades.find(grade => grade.id == this.initialGrade);
    }

    this.fetchUserSchools();
  }
}
</script>

<style lang="scss" scoped>

.card {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button {
  margin-bottom: 25px;
}

.cancel-button {
  align-self: center;
}

.edit-buddy-form {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}

.dropdown-menu {
  display: block;
  position: relative;

  width: 100%;
  padding: 0;
  margin: 0;
  margin-bottom: 25px;
  background-color: $soft-highlight;
}
</style>